import * as angular from "angular";
import { FeatureExtraDialogController } from "./feature-extra-dialog.controller";

let FeatureAutoGenerateVoterNameDialog = {
    selector: "vcFeatureAutoGenerateVoterNameDialog",
    templateUrl:
        "/angular/components/feature/feature-auto-generate-voter-name-dialog.component.html",
    bindings: {
        feature: "=",
        isOrgCampaign: "=?",
        openFeatureExtra: "&",
    },
    controller: FeatureExtraDialogController,
};
angular
    .module("feature", [])
    .component(
        FeatureAutoGenerateVoterNameDialog.selector,
        FeatureAutoGenerateVoterNameDialog
    );
